import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
	tableWrapper: {
		padding: '20px',
	},

	piviotStyle: {
		background: '#93d893',
	},

	rowBackgroundStyle: {
		background: '#e2e2e2',
	},
});

const Index = ({ piviotPoint, r1, r2, r3, s1, s2, s3 }) => {
	const classes = useStyles();

	return (
		<div className={classes.tableWrapper}>
			<TableContainer component={Paper}>
				<Table aria-label='simple table'>
					<TableBody>
						<TableRow>
							<TableCell component='th' scope='row'>
								Resistance 3
							</TableCell>
							<TableCell align='right'>{r3}</TableCell>
						</TableRow>
						<TableRow className={classes.rowBackgroundStyle}>
							<TableCell component='th' scope='row'>
								Resistance 2
							</TableCell>
							<TableCell align='right'>{r2}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell component='th' scope='row'>
								Resistance 1
							</TableCell>
							<TableCell align='right'>{r1}</TableCell>
						</TableRow>
						<TableRow className={classes.piviotStyle}>
							<TableCell component='th' scope='row'>
								Pivot Point
							</TableCell>
							<TableCell align='right'>{piviotPoint}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell component='th' scope='row'>
								Support 1
							</TableCell>
							<TableCell align='right'>{s1}</TableCell>
						</TableRow>
						<TableRow className={classes.rowBackgroundStyle}>
							<TableCell component='th' scope='row'>
								Support 2
							</TableCell>
							<TableCell align='right'>{s2}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell component='th' scope='row'>
								Support 3
							</TableCell>
							<TableCell align='right'>{s3}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default Index;
